import { PageType } from "shared/lib/page-type";

export const pathname = "/search";

export type RouteFunction = (query: QueryParameters<{ q?: string }>) => {
  asPath: string;
  pathname: string;
  query: { pageType: PageType; q?: string };
};

export const page = {
  route(this: void, query: QueryParameters<{ q?: string }>) {
    return {
      asPath: `${pathname}${query.q ? `?q=${encodeURIComponent(query.q)}` : ""}`,
      pathname,
      query: { ...query, pageType: PageType.Search },
    };
  },
};
